<template>
  <div class="cyxx">
    <div class="tabs">
      <span v-for="(item,index) in cyxx_tabs" :key="index" @click="tabClick(cyxx_tabs,item)"
        :class="item.isck?'tabs_active':''">{{item.label}}</span>
    </div>
    <table v-if="cyxx_tabs[0].isck" cellspacing="0" class="table_common">
      <tr>
        <td class="fw700 w6 br">序号</td>
        <td class="fw700 w12  bl br">所属部门</td>
        <td class="fw700 w10 bl br">部门成员</td>
        <td class="fw700 w14 bl br">联系电话</td>
        <td class="fw700 w14 bl br">职位</td>
        <td class="fw700 w12 bl br">入职时间</td>
        <td class="fw700 w10 bl br">员工类型</td>
        <td class="fw700 w10 bl br">创建人</td>
        <td class="fw700 w12 bl">创建时间</td>
      </tr>
      <tr v-for="(item,index) in cylb" :key="index">
        <td v-if="index==0" :rowspan="cylb.length">1</td>
        <td v-if="index==0" :rowspan="cylb.length">代账一部</td>
        <td>张丽娟</td>
        <td>188 6666 8888</td>
        <td>实习会计</td>
        <td>2021-03-03</td>
        <td>暂无数据</td>
        <td>郭世杰</td>
        <td>2021-03-03</td>
      </tr>
    </table>
    <table v-if="cyxx_tabs[1].isck" cellspacing="0" class="table_common h30">
      <tr>
        <td class="fw700 w6 br" rowspan="2">序号</td>
        <td class="fw700 w12  bl br" rowspan="2">所属部门</td>
        <td class="fw700 w10 bl br" rowspan="2">部门成员</td>
        <td class="fw700 w14 bl bb"></td>
      </tr>
      <tr>
        <td class="fw700 w14 bl bt"></td>
      </tr>
      <tr v-for="(item,index) in cyjx" :key="index">
        <td v-if="index==0" :rowspan="cylb.length">1</td>
        <td v-if="index==0" :rowspan="cylb.length">代账一部</td>
        <td>张丽娟</td>
        <td>188 6666 8888</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cyxx_tabs: [
        //成员信息
        { label: '成员列表', isck: true },
        { label: '成员绩效', isck: false },
      ],
      cylb: [
        //成员列表
        {},
        {},
        {},
        {},
      ],
      cyjx: [
        //成员绩效
        {},
        {},
        {},
        {},
      ],
      tabClick(data, item) {
        data.forEach((val) => {
          val.isck = false
        })
        item.isck = true
        this.lskhShow = false
        this.cpsjShow = false
        this.htsrShow = false
      },
    }
  },
}
</script>

<style>
</style>